import { IconChevronRight } from '@tabler/icons-react'
import { ReactNode } from 'react'

import { AstraIcon, AstraParagraph } from '~/astra'

type Props = {
    icon?: ReactNode
    label?: ReactNode
    description?: string
}
export const CommandPaletteOption = ({ icon, label, description }: Props) => (
    <div className="flex flex-1 items-center gap-3 overflow-hidden">
        {icon && (
            <div className="flex items-center justify-between gap-2">
                {icon}
                <span className="text-disabled">
                    <AstraIcon icon={IconChevronRight} color="text-disabled" />
                </span>
            </div>
        )}
        <div className="flex-1 overflow-hidden">
            <AstraParagraph variant="body" className="overflow-hidden truncate text-default" title={String(label)}>
                {label}
            </AstraParagraph>
            {description && (
                <AstraParagraph variant="body-small" className="truncate text-subtle">
                    {description}
                </AstraParagraph>
            )}
        </div>
    </div>
)
